import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import FilePreview from "components/Common/previewFile";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentInvestissement";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";
import DeleteButton from "components/Common/DeleteButtonShow";

import Config from "config";
import LastModificationAlert from "components/Common/Alert";
import LastModificationAlertShow from "components/Common/AlertShow";
import IdentificationCardPartenaire from "components/Common/IdentificationCardPartenaire";
import ReactInputMask from "react-input-mask";
import AuditCard from "components/Common/AuditCard";
import IdentificationCard2 from "components/Common/IdentificationCard2";
const ProjetDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal_1, setModal_1] = useState(false);
  const [modal_2, setModal_2] = useState(false);
  const [modal_3, setModal_3] = useState(false);

  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [pmeData, setPmeData] = useState([]);
  const splitObjectInHalf = (obj) => {
    if (!obj) return [{}, {}];

    const keys = Object.keys(obj);
    const halfLength = Math.ceil(keys.length / 2);

    const firstHalf = {};
    const secondHalf = {};

    keys.forEach((key, index) => {
      if (index < halfLength) {
        firstHalf[key] = obj[key];
      } else {
        secondHalf[key] = obj[key];
      }
    });

    return [firstHalf, secondHalf];
  };

  const [souscriptions_en_cours, setSouscriptions_en_cours] = useState([]);
  const [operationData, setOperationData] = useState([]);
  const [investissements, setInvestissement] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [documentFusionData, setDocumentFusionData] = useState([]);
  const [souscriptions_finalisees, setSouscriptions_finalisees] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  // edit hm document
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const [selectedPme, setSelectedPme] = useState();
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Projets | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {type_compte == "client" && !loading ? (
              "Détails " + pmeData.sil
            ) : !loading ? (
              "Détails Projets"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
        {pmeData?.hm_accessibles?.map((key, index) =>
          key === "hm_souscriptions_en_cours" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions_en_cours" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions_en_cours")}
              >
                {!loading ? (
                  souscriptions_en_cours?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_souscriptions_finalisees" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions_finalisees" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions_finalisees")}
              >
                {!loading ? (
                  souscriptions_finalisees?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_operations" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "operation" ? "active" : ""
                }`}
                onClick={() => handleTabClick("operation")}
              >
                {!loading ? (
                  operationData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_investissements" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "investissements" ? "active" : ""
                }`}
                onClick={() => handleTabClick("investissements")}
              >
                {!loading ? (
                  investissements?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents")}
              >
                {!loading ? (
                  documentData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents_fusions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents_fusions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents_fusions")}
              >
                {!loading ? (
                  documentFusionData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [downloadUrl1, setDownloadUrl1] = useState(null);

  const downloadLinkRef = useRef(null);
  const downloadLinkRef1 = useRef(null);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    if (downloadUrl && downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  }, [downloadUrl]);
  useEffect(() => {
    if (downloadUrl1 && downloadLinkRef1.current) {
      downloadLinkRef1.current.click();
    }
  }, [downloadUrl1]);
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "terraform_projet":
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/projets/${id}/terraform_projet`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.ok) {
            toast.success("Le projet a été transformé en investissement(s)");
            //refresh page
            setRefresh(!refresh);
          } else {
            toast.error("La transformation a échoué");
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;
      case "send_webhook_agridom":
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/projets/${id}/send_webhook_agridom`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.ok) {
            toast.success("Webhook envoyé avec succès");
            //refresh page
            setRefresh(!refresh);
          } else {
            toast.error("L'envoi du webhook a échoué");
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;
      default:
        toast.error("Aucune action configurée");
        break;
    }
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/projets/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const pmeData = await response.json();
        setPmeData(pmeData);
        {
          pmeData?.hm_accessibles?.map(async (key, index) =>
            key === "hm_souscriptions_en_cours"
              ? await getSouscriptionEnCours()
              : key === "hm_investissements"
              ? await getInvestissements()
              : key === "hm_documents"
              ? await getDocumentHm()
              : null
          );
        }
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const getInvestissements = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/projets/${id}/hm_investissements`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setInvestissement(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getSouscriptionEnCours = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/projets/${id}/hm_souscriptions_en_cours`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setSouscriptions_en_cours(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getDocumentHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/projets/${id}/hm_documents`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setDocumentData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      localStorage.setItem("key", "false");
    }
  }, [refresh]);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  const getDocumentDetail = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investissements_documents/${docId}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocData(data);
          setSelectedCategorie(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Catégorie"]
          );
          setSelectedPme(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Investissement"]
          );
          setSelectedType(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Type"]
          );
          setSelectedNom(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Nom"]
          );
          setSelectedFichier(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Fichier"]
          );
          setSelectedComment(
            data?.detail_investissements_document["Identification du documents"]
              .Commentaires
          );
          setModal(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [categorieData, setCategorieData] = useState({ data: [] });
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCategorieDocument = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/partenaires_documents/categories_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategorieData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [typeDocData, setTypeDocData] = useState({ data: [] });
  const renderTypeDocOptions = () => {
    return [
      {
        options: typeDocData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getTypeDoc = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/partenaires_documents/types_documents?id=${docId}&categories_document_id=${
          selectedCategories?.value || newCategories?.value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeDocData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getDocumentHm = async () => {
    try {
      await fetch(`https://www.fluxod.com/${api}/projets/${id}/hm_documents`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setDocumentData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNewSubmit = async () => {
    if (newCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (newType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newFichier == null || "") {
      toast.error("Merci de renseigner un fichier");
    } else {
      document.getElementById("create_button").disabled = true;
      const formData = new FormData();
      formData.append("investissement_id", id);
      formData.append("fichier", newFichier);
      formData.append("categories_document_id", newCategories?.value);
      formData.append("types_document_id", newType?.value);
      formData.append("nom", newNom);
      formData.append("commentaires", newComment);
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements_documents/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Ajouté");
          setModal_1(false);
          getDocumentHm();
        } else {
          document.getElementById("create_button").disabled = false;
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            responseData &&
            responseData.investissements_document_validation
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.investissements_document_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };

  const handleUpdateSubmit = async () => {
    if (selectedCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (selectedType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("id", docId);
        formData.append("investissement_id", id);
        formData.append("fichier", selectedFichier);
        formData.append("categories_document_id", selectedCategories?.value);
        formData.append("types_document_id", selectedType?.value);
        formData.append("nom", selectedNom);
        formData.append("commentaires", selectedComment);
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements_documents/${docId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Modifié");
          getDocumentHm();
          setLoading(false);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          setLoading(false);
          if (responseData && responseData.contact_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.contact_document_validation[0];
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  function extractSegment(url) {
    const baseUrl = `${backUrl}/`;
    const editSegment = "/edit";

    if (url.startsWith(baseUrl) && url.endsWith(editSegment)) {
      const start = baseUrl.length;
      const end = url.length - editSegment.length;
      return url.substring(start, end);
    }

    return null;
  }
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);

  const extractedText = extractSegment(previousPath);

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        {previousPath == `${backUrl}/${extractedText}/edit` ? (
          <LastModificationAlertShow path={extractedText} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/projets/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Projets
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        pmeData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {pmeData.can_edit ? (
                        <Link
                          to={`${backUrl}/projets/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {pmeData.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/projets/${id}`}
                        />
                      ) : null}
                      {pmeData?.actions?.length > 0 ? (
                        <>
                          <>
                            &nbsp; &nbsp;
                            <Dropdown
                              isOpen={btnsecondary1}
                              toggle={() => setBtnsecondary1(!btnsecondary1)}
                            >
                              <DropdownToggle
                                tag="button"
                                className="btn btn-sm btn-secondary"
                              >
                                Actions <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {pmeData?.actions.map((value, index) => (
                                  <>
                                    <DropdownItem
                                      onClick={() =>
                                        handleDropDownActionsClick(value.action)
                                      }
                                    >
                                      {value.label}
                                    </DropdownItem>
                                  </>
                                ))}
                                {downloadUrl && (
                                  <a
                                    href={downloadUrl}
                                    download={`${pmeData.sil.replace(
                                      / /g,
                                      "_"
                                    )}_Tableau_PME_${new Date()
                                      .toLocaleString("fr-FR", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })
                                      .replace(/[/: ]/g, "_")}.xlsx`}
                                    ref={downloadLinkRef}
                                    style={{ display: "none" }}
                                  >
                                    Télécharger le fichier excel
                                  </a>
                                )}
                                {downloadUrl1 && (
                                  <a
                                    href={downloadUrl1}
                                    download={`${pmeData.sil.replace(
                                      / /g,
                                      "_"
                                    )}_CERFA_2083_${new Date()
                                      .toLocaleString("fr-FR", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })
                                      .replace(/[/: ]/g, "_")}.xlsx`}
                                    ref={downloadLinkRef1}
                                    style={{ display: "none" }}
                                  >
                                    Télécharger le fichier excel
                                  </a>
                                )}
                              </DropdownMenu>
                            </Dropdown>
                          </>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Row>
                              <>
                                <Col sm="12">
                                  {pmeData?.detail_projet?.Identication ? (
                                    <IdentificationCard2
                                      title="Identification"
                                      details={
                                        pmeData?.detail_projet?.Identication
                                      }
                                      ids={pmeData?.detail_projet?.ids}
                                    />
                                  ) : null}
                                </Col>
                              </>
                            </Row>
                            <Row>
                              {pmeData?.detail_projet?.["Lot 1"] ? (
                                <>
                                  <Col sm="6">
                                    <IdentificationCard
                                      title="Lot 1"
                                      details={
                                        pmeData?.detail_projet?.["Lot 1"]
                                      }
                                      ids={pmeData?.detail_projet?.ids}
                                    />
                                  </Col>{" "}
                                  <Col sm="6">
                                    <IdentificationCard
                                      title="Lot 2"
                                      details={
                                        pmeData?.detail_projet?.["Lot 2"]
                                      }
                                      ids={pmeData?.detail_projet?.ids}
                                    />
                                  </Col>{" "}
                                </>
                              ) : null}
                            </Row>
                            <Row>
                              <Col sm="6">
                                {pmeData?.detail_projet?.["Total"] ? (
                                  <IdentificationCard
                                    title="Total"
                                    details={pmeData?.detail_projet?.["Total"]}
                                  />
                                ) : null}
                              </Col>
                            </Row>
                            <Col sm="6">
                              <Row>
                                {pmeData?.detail_projet?.[
                                  "Renseignements juridiques"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Renseignements juridiques"
                                    details={
                                      pmeData?.detail_projet?.[
                                        "Renseignements juridiques"
                                      ]
                                    }
                                  />
                                ) : null}

                                {pmeData?.detail_projet?.[
                                  "Réduction d'impôt (DOM COM)"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Réduction d'impôt (DOM COM)"
                                    details={
                                      pmeData?.detail_projet?.[
                                        "Réduction d'impôt (DOM COM)"
                                      ]
                                    }
                                  />
                                ) : null}
                              </Row>
                            </Col>
                            <Row>
                              <Col sm="12">
                                <TableComponent
                                  title="Investissements"
                                  header={
                                    pmeData?.detail_projet?.[
                                      "Investissements"
                                    ]?.["Investissements"]?.header
                                  }
                                  data={
                                    pmeData?.detail_projet?.[
                                      "Investissements"
                                    ]?.["Investissements"]?.data
                                  }
                                />
                              </Col>
                            </Row>

                            <Row>
                              <Col sm="12">
                                {" "}
                                {pmeData?.detail_projet?.Audit ? (
                                  <AuditCard
                                    title="Audit"
                                    auditData={pmeData?.detail_projet?.Audit}
                                  />
                                ) : null}
                              </Col>
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          {documentData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_1(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}
                          <DocumentHm
                            title={documentData}
                            data={documentData?.data}
                            header={documentData?.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getDocumentDetail(documentId);
                              getTypeDoc(documentId);
                              getCategorieDocument();
                              setDocId(documentId);
                            }}
                            controller="investissements_documents"
                          />
                          <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                            <ModalHeader
                              toggle={() => setModal(!modal)}
                              tag="h4"
                            >
                              Détails du document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  setModal(false);
                                  handleUpdateSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investissement
                                      </Label>
                                      <Input
                                        name="investissement"
                                        type="text"
                                        placeholder="Investissement"
                                        value={pmeData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={selectedCategories}
                                        onChange={handleCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={selectedType}
                                        onChange={handleTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={selectedNom}
                                        onChange={(e) =>
                                          setSelectedNom(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={selectedComment}
                                        onChange={(e) =>
                                          setSelectedComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier :
                                      </Label>
                                      <FilePreview
                                        fileUrl={
                                          docData
                                            ?.detail_investissements_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                      />
                                      <a
                                        href={
                                          docData
                                            ?.detail_investissements_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Télécharger le fichier
                                      </a>
                                      <input
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        className="btn btn-success save-user"
                                      >
                                        Enregistrer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_1}
                            toggle={() => setModal_1(!modal_1)}
                          >
                            <ModalHeader
                              toggle={() => setModal_1(!modal_1)}
                              tag="h4"
                            >
                              Nouveau document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investissement
                                      </Label>
                                      <Input
                                        name="investissement"
                                        type="text"
                                        placeholder="investissement"
                                        value={pmeData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={newCategories}
                                        onChange={handleNewCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={newNom}
                                        onChange={handleNomChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={newComment}
                                        onChange={(e) =>
                                          setNewComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier
                                      </Label>

                                      <input
                                        type="file"
                                        onChange={handleNewFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default ProjetDetail;
